/* Ott-common */
import { normalize } from '@dtvgo/typed-normalizr';
import { AuthType } from '@dtvgo/axios-interceptor-auth';
import { OrbisResourceType } from '@dtvgo/constants';

/* Utils */
import { VodContentEntity } from '../../utils';

export default function vod(backendAxiosInstance) {
  async function getVodContentDataById(resourceType, contentId) {
    let resourceTypeUrl;

    switch (resourceType) {
      case OrbisResourceType.VOD_MOVIE:
        resourceTypeUrl = 'Movies';
        break;
      case OrbisResourceType.VOD_COMPETITION:
        resourceTypeUrl = 'Competitions';
        break;
      case OrbisResourceType.VOD_TEAM_COMPETITION:
        resourceTypeUrl = 'TeamCompetitions';
        break;
      case OrbisResourceType.VOD_EPISODE:
        resourceTypeUrl = 'Episodes';
        break;
      case OrbisResourceType.VOD_EVENT:
        resourceTypeUrl = 'Events';
        break;
      default:
        throw new Error('A known resourceType is required');
    }

    const response = await backendAxiosInstance.get(`/content/v1/Vod/${resourceTypeUrl}/${contentId}`, {
      authType: AuthType.SESSION_TOKEN,
    });

    response.normalizedData = normalize(response.data, VodContentEntity);

    return response;
  }

  return {
    getVodContentDataById,
  };
}
